import axios from 'axios';
import { ColorInfo, SubscriptionStatus } from '../types/color';

const BASE = process.env.REACT_APP_API_URL ?? '/api';

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token') ?? ''}` },
});

export const getColorCatalog = () =>
  axios.get<ColorInfo[]>(`${BASE}/colors/`, authHeaders());

export const purchaseColor = (color: string) =>
  axios.post<{ message: string; color: string }>(
    `${BASE}/colors/purchase`,
    { color },
    authHeaders(),
  );

export const getSubscriptionStatus = () =>
  axios.get<SubscriptionStatus>(`${BASE}/subscription/status`, authHeaders());

export const purchaseSubscription = () =>
  axios.post<SubscriptionStatus>(`${BASE}/subscription/purchase`, {}, authHeaders());
